import { Box, Text } from '@wix/design-system';
import React from 'react';
import s from './MarketingItemRow.scss';
import { FeatureIcon } from './ProductFeatureIcon';
import classNames from 'classnames';
export function MarketingItemRow({ item, zIndex, boxShadow, paddingBottom, className, disabled = false, }) {
    const { text, prefixIconUrl, suffixIconUrl } = item;
    return (React.createElement(Box, { gap: "SP1", padding: `SP4 0 ${paddingBottom} 0`, zIndex: zIndex, boxShadow: boxShadow, className: className },
        React.createElement(Box, { width: "85%", maxWidth: "188px", margin: "0 auto" },
            React.createElement(Text, { size: "small", className: classNames(s.text, { [s.disabled]: disabled }) },
                prefixIconUrl && (React.createElement(FeatureIcon, { iconUrl: prefixIconUrl, marginRight: "SP1", disabled: disabled })),
                text,
                suffixIconUrl && (React.createElement(FeatureIcon, { iconUrl: suffixIconUrl, marginLeft: "SP1", disabled: disabled }))))));
}
//# sourceMappingURL=MarketingItemRow.js.map